import { useState } from "react";
import { hitApi } from "../utils/apiCall";
import { downloadPayslip } from "./downloadPayslip";
import toast from "react-hot-toast";

const useFetchPayRoleDetails = (month, empId) => {
  const [payRoleData, setPayRoleData] = useState([]);
  const [loadingPayRoles, setLoadingPayRoles] = useState(true);
  const [errorPayRoles, setErrorPayRoles] = useState(null);

  const fetchPayRoleData = async (month, empId) => {
    try {
      setLoadingPayRoles(true);
      const fd = new FormData();

      fd.append("month", month?.split("-")?.reverse().join("-"));
      if (Array.isArray(empId) && empId.length > 0) {
        empId.forEach((emp) => fd.append("staff_id[]", emp));
      } else if (empId) {
        fd.append("staff_id[]", empId);
      }
      fd.append("limit", 1000);
      // fd.forEach((v, k) => console.log(k, v));
      const result = await hitApi(
        "payRoll/payRollDetails",
        "getGeneratedPayrollDetails",
        fd
      );
      // console.log(result);

      if (result.success) {
        if (Array.isArray(result.data) && result.data.length > 0) {
          setPayRoleData(result.data);
          downloadPayslip(result.data?.[0]);
          setErrorPayRoles(null);
          toast.success("Payslip Downloaded");
        } else {
          toast.error("No Payslip Found");
        }
      } else {
        setPayRoleData([]);
        setErrorPayRoles(new Error("Failed to fetch role data."));
      }
    } catch (err) {
      setPayRoleData([]);
      setErrorPayRoles(err);
    } finally {
      setLoadingPayRoles(false);
    }
  };

  return { payRoleData, loadingPayRoles, errorPayRoles, fetchPayRoleData };
};

export default useFetchPayRoleDetails;
